export default __webpack_public_path__ + "static/media/kramnik.71cf60a3.txt";